/**
 * PopupCloseButton — ЄДИНИЙ хрестик закриття для ВСІХ попапів (owner 2026-07-10:
 * «щоб не було так, що одні попапи з хрестиком у сірому кружечку, а інші —
 * просто з хрестиком»). Стиль: × (SVG, ідеально по центру) у напівпрозорому
 * сірому кружечку, absolute у правому-верхньому куті.
 *
 * Батьківський контейнер попапу МАЄ бути `relative`.
 */
import { Icon } from "@/components/Icon";

export function PopupCloseButton({
  onClose,
  className = "",
}: {
  onClose: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label="Закрити"
      className={
        "absolute right-3 top-3 z-10 grid h-7 w-7 place-items-center rounded-full " +
        "bg-ink/[0.06] text-ink-dim active:scale-90 transition " +
        className
      }
    >
      <Icon name="plus" size={14} className="rotate-45" />
    </button>
  );
}
